"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.voiceMailsSelector = exports.voiceMailsLoadingSelector = exports.voiceMailsErrorSelector = exports.voiceMailSupportedSelector = exports.voiceMailEntitiesSelector = exports.voiceMailCountSelector = exports.unreadVoiceMailCountSelector = exports.getVoiceMailByIdSelector = exports._voiceMailsSelector = void 0;
var _reselect = require("reselect");
var _selectors = require("../entities/selectors");
var voiceMailsSelector = state => state.voiceMails;
exports.voiceMailsSelector = voiceMailsSelector;
var voiceMailEntitiesSelector = state => (0, _selectors.entitiesSelector)(state).voiceMails;
exports.voiceMailEntitiesSelector = voiceMailEntitiesSelector;
var _getVoiceMailParameter = (state, _voiceMail) => _voiceMail;
var _voiceMailsSelector = state => {
  var _voiceMailsSelector2;
  return (_voiceMailsSelector2 = voiceMailsSelector(state)) === null || _voiceMailsSelector2 === void 0 ? void 0 : _voiceMailsSelector2.items;
};
exports._voiceMailsSelector = _voiceMailsSelector;
var voiceMailsLoadingSelector = state => {
  var _voiceMailsSelector3;
  return (_voiceMailsSelector3 = voiceMailsSelector(state)) === null || _voiceMailsSelector3 === void 0 ? void 0 : _voiceMailsSelector3.loading;
};
exports.voiceMailsLoadingSelector = voiceMailsLoadingSelector;
var voiceMailsErrorSelector = state => {
  var _voiceMailsSelector4;
  return (_voiceMailsSelector4 = voiceMailsSelector(state)) === null || _voiceMailsSelector4 === void 0 ? void 0 : _voiceMailsSelector4.error;
};
exports.voiceMailsErrorSelector = voiceMailsErrorSelector;
var unreadVoiceMailCountSelector = state => {
  var _voiceMailsSelector5;
  return (_voiceMailsSelector5 = voiceMailsSelector(state)) === null || _voiceMailsSelector5 === void 0 ? void 0 : _voiceMailsSelector5.unreadCount;
};
exports.unreadVoiceMailCountSelector = unreadVoiceMailCountSelector;
var voiceMailCountSelector = state => {
  var _voiceMailsSelector6;
  return (_voiceMailsSelector6 = voiceMailsSelector(state)) === null || _voiceMailsSelector6 === void 0 ? void 0 : _voiceMailsSelector6.count;
};
exports.voiceMailCountSelector = voiceMailCountSelector;
var voiceMailSupportedSelector = state => {
  var _voiceMailsSelector7;
  return (_voiceMailsSelector7 = voiceMailsSelector(state)) === null || _voiceMailsSelector7 === void 0 ? void 0 : _voiceMailsSelector7.isVoiceMailSupported;
};
exports.voiceMailSupportedSelector = voiceMailSupportedSelector;
var getVoiceMailByIdSelector = exports.getVoiceMailByIdSelector = (0, _reselect.createSelector)([_getVoiceMailParameter, voiceMailEntitiesSelector], (_voiceMail, voiceMails) => voiceMails === null || voiceMails === void 0 ? void 0 : voiceMails[_voiceMail]);